<template>
  <div class='page-test'>
    <h1>{{ serviceTestCode }}</h1>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      serviceTestCode: 'user/serviceTestCode',
    }),
  },
  created() {
    this.serviceTest();
  },
  methods: {
    ...mapActions({
      serviceTest: 'user/serviceTest',
    }),
  },
};
</script>

<style lang="less" scoped>
.page-test {
  overflow: hidden;
  text-align: center;
  h1 {
    margin-top: 30px;
    font-size: 60px;
    color: transparent;
    background-image: -webkit-linear-gradient(bottom, rgb(201, 115, 255), rgb(20, 11, 255));
    background-clip: text;
    -webkit-background-clip: text;
    text-shadow: 6px 6px 10px gray;
  }
}
</style>
